// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ContactCorrespondenceAddressModel from '../../model/contact-correspondence-address-model';
import ContactCorrespondenceAddressDTO from '../dto/contact-correspondence-address-dto';
import dtoSchema from '../schemas/contact-correspondence-address-schema';
import ContactAddressModel from '../../model/contact-address-model';

export default abstract class ContactCorrespondenceAddressModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ContactCorrespondenceAddressDTO>) {
    super();
    if (data) {
      this.isDifferent = data.isDifferent;
      this.contactAddress = data.contactAddress ? ContactAddressModel.toModel(data.contactAddress) : undefined;
    }
  }
  /**
  */
  isDifferent?: boolean;
  /**
  */
  contactAddress?: ContactAddressModel;

  static toModel(dto: DeepPartial<ContactCorrespondenceAddressDTO>): ContactCorrespondenceAddressModel;
  static toModel(dto: DeepPartial<ContactCorrespondenceAddressDTO> | undefined | null): ContactCorrespondenceAddressModel | undefined;
  static toModel(dto: DeepPartial<ContactCorrespondenceAddressDTO> | undefined | null): ContactCorrespondenceAddressModel | undefined {
    return dto ? new ContactCorrespondenceAddressModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ContactCorrespondenceAddressModel> | ContactCorrespondenceAddressModel): ContactCorrespondenceAddressDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      isDifferent: unwrapped.isDifferent,
      contactAddress: unwrapped.contactAddress,
    } as ContactCorrespondenceAddressDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ContactCorrespondenceAddressModel, can not map to ContactCorrespondenceAddressDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
